import { Component, OnInit } from '@angular/core';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { SelfcorrectingService } from '../selfcorrecting.service';

@Component({
  selector: 'app-ct-compute-bits',
  templateUrl: './ct-compute-bits.component.html',
  styleUrls: ['./ct-compute-bits.component.css']
})
export class CtComputeBitsComponent extends GeneralExerciseComponent {

  message: string;
  dimension: number[] = [0, 0];
  modus: string;
  encoding: string = "cardTrick";
  highlight: boolean = false;
  useSymbols: boolean = false;

  messageArray: number[][] = [];
  c: number[] =[];

  currentRow: number;
  currentColumn: number;

  selectedRow: number;
  selectedColumn: number;

  correctedMessage: string;
  hamming: string;

  showMessage: string;

  p: string[] = [];

  currentParity: number[] = [];


  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService, protected selfcorrectingService: SelfcorrectingService) {
    super(activatedRoute, topicService, messageService)
  }

  setTypeSpecificsFromConfiguration() {
    this.message = this.configuration.typespecifics.message;
    this.dimension = this.configuration.typespecifics.dimension;
    this.modus = this.configuration.typespecifics.modus;
    this.encoding = this.configuration.typespecifics.encoding;
    this.useSymbols = this.configuration.typespecifics.useSymbols;
    this.highlight = this.configuration.typespecifics.highlight;


    this.c = [];
    this.p = [];
    this.correctedMessage = "";
    if (this.modus == "controlBits") {
      if (this.encoding == "cardTrick") {
        this.correctedMessage = this.message;
      } else {
        this.computeCorrectMessage();
      }
    } else {
    }
    this.computeShowMessage();

    this.messageArray = [];
    if (this.encoding == "cardTrick") {
      let index = 0;
      for (let i = 0; i < this.dimension[0]; i++) {
        let elem = [];
        if (this.modus == "controlBits") {
          for (let j = 0; j < this.dimension[1]; j++) {
            elem[j] = this.message.charAt(index);
            index++;
          }
        }
        this.messageArray.push(elem);
      }
      this.printable = true;
    } else {
      if (this.modus == "controlBits") {
        this.p[0] = "";
        this.p[1] = "";
        this.p[2] = "";
        this.p[3] = "";
        for (let i of this.selfcorrectingService.allCodes(4)) {
          if (i != "0000" && !this.powerOfTwo(parseInt(i, 2))) {
            for (let j = 0; j < 4; j++) {
              if (i.charAt(j) == "1") {
                this.p[3 - j] = this.p[3 - j].concat(this.showMessage.charAt(parseInt(i, 2) - 1), " ");
              }
            }
          }
        }
      }
    }

  }

  setTypeSpecificsFromState() {
    if (this.state.typespecific) {
      if (this.state.typespecific.selectedColumn != undefined) {
        this.selectedColumn = this.state.typespecific.selectedColumn;
      }
      if (this.state.typespecific.selectedRow != undefined) {
        this.selectedRow = this.state.typespecific.selectedRow;
      }
      if (this.state.typespecific.correctedMessage) {
        this.correctedMessage = this.state.typespecific.correctedMessage;
      }
      if (this.state.typespecific.messageArray) {
        this.messageArray = this.state.typespecific.messageArray;
      }

      if (this.state.typespecific.c) {
        this.c = this.state.typespecific.c;
      }

      if (this.state.typespecific.p) {
        this.p = this.state.typespecific.p;
      }
    }

  }

  computeState() {
    this.state.typespecific.correctedMessage = this.correctedMessage;
    this.state.typespecific.messageArray = this.messageArray;
    this.state.typespecific.c = this.c;
    this.state.typespecific.p = this.p;
  }

  checkSolution() {
    let solution = "";
    if (this.encoding == "cardTrick") {
      let messageArray = [];
      let index = 0;
      for (let i = 0; i < this.dimension[0]; i++) {
        let elem = [];
        for (let j = 0; j < this.dimension[1]; j++) {
          elem[j] = this.message.charAt(index);
          index++;
        }
        messageArray.push(elem);
      }
      let correctc = this.selfcorrectingService.controlBits(messageArray, this.dimension);
      solution = this.message.concat(correctc.join(""));
    } else {
      let p = [];
      p[0] = "";
      p[1] = "";
      p[2] = "";
      p[3] = "";
      for (let i of this.selfcorrectingService.allCodes(4)) {
        if (i != "0000" && !this.powerOfTwo(parseInt(i, 2))) {
          for (let j = 0; j < 4; j++) {
            if (i.charAt(j) == "1") {
              p[3 - j] = p[3 - j].concat(this.showMessage.charAt(parseInt(i, 2) - 1), " ");
            }
          }
        }
      }
      let c = p.map(v => v.split("").map(v => +v).reduce((a, b) => a + b, 0)).map(v => v % 2);
      let dataI = 0;
      let parityI = 0;
      for (let i = 1; i < 16; i++) {
        if (this.powerOfTwo(i)) {
          solution = solution.concat(c[parityI].toString());
          parityI++;
        } else {
          solution = solution.concat(this.message.charAt(dataI));
          dataI++;
        }
      }
    }
    if (this.correctedMessage == solution) {
      this.state.solved = true;
      this.solved = true;
      this.saveState();
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("wrongAnswer"), "danger", 10000);
    }
  }

  evaluate(): number[] {
    let solution = "";
    let length  = -1;
    if (this.encoding == "cardTrick") {
      length = this.dimension[0] + this.dimension[1] + 1;
      let messageArray = [];
      let index = 0;
      for (let i = 0; i < this.dimension[0]; i++) {
        let elem = [];
        for (let j = 0; j < this.dimension[1]; j++) {
          elem[j] = this.message.charAt(index);
          index++;
        }
        messageArray.push(elem);
      }
      let correctc = this.selfcorrectingService.controlBits(messageArray, this.dimension);
      solution = this.message.concat(correctc.join(""));
    } else {
      length = 4;
      let p = [];
      p[0] = "";
      p[1] = "";
      p[2] = "";
      p[3] = "";
      for (let i of this.selfcorrectingService.allCodes(4)) {
        if (i != "0000" && !this.powerOfTwo(parseInt(i, 2))) {
          for (let j = 0; j < 4; j++) {
            if (i.charAt(j) == "1") {
              p[3 - j] = p[3 - j].concat(this.showMessage.charAt(parseInt(i, 2) - 1), " ");
            }
          }
        }
      }
      let c = p.map(v => v.split("").map(v => +v).reduce((a, b) => a + b, 0)).map(v => v % 2);
      let dataI = 0;
      let parityI = 0;
      for (let i = 1; i < 16; i++) {
        if (this.powerOfTwo(i)) {
          solution = solution.concat(c[parityI].toString());
          parityI++;
        } else {
          solution = solution.concat(this.message.charAt(dataI));
          dataI++;
        }
      }
    }
    let error = solution.split("").filter((v,i) => v != this.correctedMessage.split("")[i]);
    return [Math.max(2*(length - error.length)/length,0), 2]
   
  }

  /** recompute corrected message */
  onChangeC() {
    if (this.modus == "controlBits") {
      if (this.encoding == "cardTrick") {
        let message = this.messageArray.map(v => v.join("")).join("");
        this.correctedMessage = message.concat(this.c.join(""));
      } else {
        this.computeCorrectMessage();
      }
    }
  }

  /** number to code 
   * @param i - number to encode
   * @param length - length of code
  */
  toString(i: number, length: number) {
    return "0".repeat(length).concat(i.toString(2)).slice(-length);
  }

  /** is number a power of 2?
   * @param x - number to check
   */
  powerOfTwo(x: number): boolean {
    return (Math.log(x) / Math.log(2)) % 1 === 0
  }

  /**
   * returns 2^i
   * @param i - power
   */
  pow2(i: number): number {
    return Math.pow(2, i);
  }

  /** compute the message to show */
  computeShowMessage() {
    let dataI = 0;
    let parityI = 0;
    this.showMessage = "";
    for (let i = 1; i < 16; i++) {
      if (this.powerOfTwo(i)) {
        if (this.c[parityI] != undefined) {
          this.showMessage = this.showMessage.concat(this.c[parityI].toString());
        } else {
          this.showMessage = this.showMessage.concat("c");
        }
        parityI++;
      } else {
        this.showMessage = this.showMessage.concat(this.message.charAt(dataI));
        dataI++;
      }
    }
  }

  /** compute the corrected message */
  computeCorrectMessage() {
    let dataI = 0;
    let parityI = 0;
    this.correctedMessage = "";
    for (let i = 1; i < 16; i++) {
      if (this.powerOfTwo(i)) {
        if (this.c[parityI] != undefined && this.c[parityI].toString() != "") {
          this.correctedMessage = this.correctedMessage.concat(this.c[parityI].toString());
        } else {
          this.correctedMessage = this.correctedMessage.concat("c");
        }
        parityI++;
      } else {
        this.correctedMessage = this.correctedMessage.concat(this.message.charAt(dataI));
        dataI++;
      }
    }
  }


  /** normalite the code */
  normalize(s: any): string {
    if (s == undefined) {
      return "";
    }
    return s.toString().replace(/[^01]/, "");
  }

  /** compute which number to highlight */
  computeCurrentParitiy(i: number) {
    if (this.encoding == "hammingCode") {
      this.currentParity = [];
      for (let j of this.selfcorrectingService.allCodes(4)) {
        if (j != "0000") {
          if (j.charAt(3 - i) == "1") {
            this.currentParity.push(parseInt(j, 2));
          }
        }
      }
    } else {
      this.currentParity = [i];
    }
  }

  /** set the parity */
  onKeyUp(oField) {
    if (oField.selectionStart || oField.selectionStart == '0') {
      this.currentParity = [oField.selectionStart+1];
    }
  }

  /** flip the i-th control bit
   * @param i - controlbit to flip
   */
  changeC(i: number){
    if(this.c[i] == 0){
      this.c[i] = 1;
    } else {
      this.c[i] = 0;
    }
    this.onChangeC();
  }


}
